// import 'bootstrap-sass';
import '@babel/polyfill';

import { initTopBar, showTopBar, hideTopBar } from 'js/utils/topbar';
import { trackConvertica } from 'js/utils/convertica';
import { initSticky } from './utils/sticky';
import { trackSomeoneWasSignedUpInLast30Days } from './utils/signupTracking';
import { teardownView } from './views/teardownView';
import { setupAppView } from './views/setupAppView';
import { View } from './views/types';
import { initCollapsibles } from './enhancements/collapse';
import { initModal } from './enhancements/modal';
import { registerServiceWorker } from './registerServiceWorker';

const redirectOnboarded = (): void => {
  const field = document.getElementById('onboarding_redirect');

  if (!field) {
    return;
  }

  const redirectPath = (field as HTMLInputElement).value;
  setTimeout(() => window.location.replace(redirectPath), 200);
};

let currentView: View | void;

const handleDOMContentLoaded = async () => {
  console.info('User DOMConentLoaded: Setup started');
  initTopBar();
  showTopBar();

  trackSomeoneWasSignedUpInLast30Days();
  initSticky();

  try {
    await trackConvertica();
  } catch (e) {
    console.info('Convertica not tracked');
  }

  initCollapsibles();
  initModal();

  redirectOnboarded();
  currentView = setupAppView();
  hideTopBar();

  console.info('User DOMConentLoaded: Setup done');
};

const handleDocumentUnload = () => {
  if (currentView) {
    teardownView(currentView);
  }
};

document.addEventListener('DOMContentLoaded', handleDOMContentLoaded, { once: true });
window.addEventListener('unload', handleDocumentUnload, false);

registerServiceWorker();
